import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import LopMauApi from '../../api/LopMauApi';
import Select from 'react-select';
import Pagination from 'react-bootstrap-4-pagination';
import InputColor from 'react-input-color';
import './LopMau.css'
import ThongBao from '../../core/ThongBao';
import { set } from 'ol/transform';
import Authen from '../../core/Authen';

export const LopMau = () => {
    const [listLopMaus, setLopMau] = useState([]);
    const [show, setShow] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [isDelete, setDelete] = useState(false);
    const handleClose = () => setShow(false);
    const { register, handleSubmit, reset } = useForm();
    const [filter, setFilter] = useState('');
    const [selectedOption, setSelectedOption] = useState();
    const [myStatus, setStatus] = useState(true);

    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);

    const listTypes = [
        { value: '', label: 'Chọn lớp bản đồ' },
        { value: '1', label: 'Lớp nền' },
        { value: '2', label: 'Lớp thổ nhưỡng' },
        { value: '3', label: 'Lớp bản đồ chất lượng đất' },
        { value: '4', label: 'Lớp bản đồ mức độ thích hợp' },
        { value: '5', label: 'Lớp bản đồ đề xuất sử dụng đất' }
    ];
    // const [myColor, setColor] = useState('#3cd6bf');
    const [myColor, setColor] = React.useState({});

    let pageIndex = 1;
    let pageSize = 20;
    const [paginationConfig, setPaging] = useState({
        totalPages: 20,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        onClick: function (page) {
            pageIndex = page;
            loadLopMau();
        }
    });

    const loadLopMau = async () => {
        try {
            const params = {
                pageIndex: pageIndex,
                pageSize: pageSize,
                keyword: filter,
                _type: ''
            }
            const response = await LopMauApi.getPaging(params);
            response.Items.forEach(item => {
                item.Checked = false;
            });
            paginationConfig.totalPages = Math.ceil(response.TotalRow / 20) == 0 ? 1 : Math.ceil(response.TotalRow / 20);
            paginationConfig.currentPage = pageIndex;
            setPaging(paginationConfig);
            setLopMau(response.Items);
        } catch (err) {
        }
    }

    useEffect(() => {
        loadLopMau();
        setRoleAdd(Authen.checkQuyen('LOPMAU_CREATE'));
        setRoleEdit(Authen.checkQuyen('LOPMAU_UPDATE'));
        setRoleDel(Authen.checkQuyen('LOPMAU_DELETE'));
    }, []);

    const timKiem = () => {
        loadLopMau();
    }

    function onChangeFilter(e) {
        setFilter(e.target.value)
    }

    const saveData = (data) => {
        if (selectedOption) {
            data.Type = selectedOption.value;
        }
        data.MauSac = myColor.hex;
        data.Status = myStatus;
        if (data.Id === "0") {
            LopMauApi.post(data).then(() => {
                setShow(false);
                loadLopMau();
            })
        }
        else {
            LopMauApi.put(data).then(() => {
                setShow(false);
                loadLopMau();
            })
        }
    }

    const clickRow = (id) => {
        listLopMaus.forEach(item => {
            if (item.Id === id) {
                item.Checked = !item.Checked;
            }
        });
        setLopMau([...listLopMaus]);
        let list = listLopMaus.filter(x => x.Checked);
        if (list.length == 1) {
            setDelete(true);
            setEdit(true);
        }
        else {
            setDelete(false);
            setEdit(false);
        }
    }

    const handleShowAdd = () => {
        reset({
            Id: 0,
            MaMau: null,
            MauSac: null
        }, [reset]);
        setShow(true);
        setSelectedOption(listTypes[0]);
        setColor({ hex: '#000000' });
    };

    const handleShowEdit = () => {
        let index = listLopMaus.findIndex(x => x.Checked);
        if (index !== -1) {
            LopMauApi.getDetail(listLopMaus[index].Id).then((response) => {
                reset({
                    Id: response.Id,
                    MaMau: response.MaMau,
                    MauSac: response.MauSac,
                    DuongKe: response.DuongKe,
                    Status: response.Status,
                    Type: response.Type,
                    Ten: response.Ten
                }, [reset])
                setStatus(response.Status);
                var index = listTypes.findIndex(x => x.value == response.Type);
                setSelectedOption(listTypes[index]);
                setColor({ hex: response.MauSac });
                setShow(true);
            });
        }
    }

    const handleShowDel = () => {

        let index = listLopMaus.findIndex(x => x.Checked);
        if (index !== -1) {
            ThongBao.printConfirmationDialog("Bạn có muốn xóa lớp màu không?", () => {
                LopMauApi.delete(listLopMaus[index].Id).then(() => {
                    ThongBao.printSuccessMessage("Xóa thành công!");
                    loadLopMau();
                })
            });
        }
    }

    const checkBoHandler = () => {              
       
    }

    const checkStatus = (e) => {
        setStatus(e);
    }

    const onChangeType = (e) => {
        setSelectedOption(e);
    }

    const onColorChange = (updatedColor) => {
        setColor(updatedColor);

    };

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h6 className="m-0 font-weight-bold text-primary">Mã màu</h6>
                </div>
                <div className="input-group col-md-4">
                    <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                    <div className="input-group-append">
                        <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                    </div>
                </div>
                <div className="col-md-4 bd-button text-right">               
                    {roleAdd == true ?<Button variant="success" size="sm" onClick={handleShowAdd}><i className='fas fa-plus'></i> Thêm</Button>:''}
                    {roleEdit == true ?<Button variant="primary" size="sm" disabled={!isEdit} onClick={handleShowEdit}><i className='far fa-edit'></i> Sửa</Button>:''}
                    {roleDel == true ?<Button variant="danger" size="sm" disabled={!isDelete} onClick={handleShowDel}><i className='fas fa-trash-alt'></i> Xóa</Button>:''}
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-bordered" width="100%">
                        <thead>
                            <tr>
                                <th className="col-checkbox"></th>
                                <th className="trang-thai">Màu sắc</th>
                                <th>Mã màu</th>
                                <th>Đường kẻ</th>
                                <th>Tên</th>
                                <th>Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listLopMaus.map((item, key) => {
                                    return (
                                        <tr onClick={() => clickRow(item.Id)} key={key}>
                                            <td className="col-checkbox">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={() => checkBoHandler()} />
                                                </div>
                                            </td>
                                            <td className="col-mau-sac">
                                                <div style={{ backgroundColor: item.MauSac }}>{item.MauSac}</div>
                                            </td>
                                            <td>{item.MaMau}</td>
                                            <td>{item.DuongKe}</td>
                                            <td>{item.Ten}</td>
                                            <td className="trang-thai">
                                                <span>{item.Status ? 'Kích hoạt' : 'Khóa'}</span>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="col-md-12 text-right">
                    <Pagination {...paginationConfig} />
                </div>
            </div>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Mã màu</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="user" onSubmit={handleSubmit(saveData)}>
                        <input name="Id" hidden={true} ref={register}></input>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Mã màu</label>
                            <div className="col-sm-9">
                                <input name="MaMau" type="text" className="form-control" placeholder="Mã màu" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Màu sắc</label>
                            <div className="col-sm-9">
                                <InputColor
                                    initialValue={myColor.hex}
                                    onChange={onColorChange}
                                    placement="right"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Đường kẻ</label>
                            <div className="col-sm-9">
                                <input name="DuongKe" type="text" className="form-control" placeholder="Đường kẻ" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Tên</label>
                            <div className="col-sm-9">
                                <input name="Ten" type="text" className="form-control" placeholder="Tên lớp màu" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Lớp bản đồ</label>
                            <div className="col-sm-9">
                                <Select
                                    className="select"
                                    name="Type"
                                    placeholder="Chọn lớp bản đồ"
                                    defaultValue={selectedOption}
                                    onChange={onChangeType}
                                    options={listTypes}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label"></label>
                            <div className="col-sm-9">
                                <input name="Status" type="checkbox" className="form-form-check-input" placeholder="Kích hoạt" checked={myStatus} onChange={() => checkStatus(!myStatus)} />
                                <span className="helping-el"></span> Kích hoạt
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" size="sm" onClick={handleSubmit(saveData)}><i className='fas fa-save'></i>&nbsp;Lưu</Button>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-sign-out-alt"></i>&nbsp;Hủy</Button>
                </Modal.Footer>
            </Modal>
        </div>

    )
}
